import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import get from 'lodash/get';
import { useAction } from 'hooks';
import Form from 'components/Form';
import Button from 'components/Form/Button';
import ButtonsContainer from 'components/Form/ButtonsContainer';
import FormGroup from 'components/Form/FormGroup';
import Input from 'components/Form/Input';
import App from 'modules/App';
import history from 'helpers/history';
import { AppContext } from 'context';
import { DELETE_ACCOUNT_FORM } from '../../constants';
import * as actions from '../../actions';
import * as selectors from '../../selectors';
import messages from '../../messages';
import validatorRules from './validatorRules.json';
const DeleteAccountForm = ({ backRouteName })=>{
    const { getUrl } = useContext(AppContext);
    const backUrl = getUrl(backRouteName);
    const formValues = useSelector(App.selectors.formSelector(DELETE_ACCOUNT_FORM));
    const isClean = !get(formValues, 'originalValues');
    const isMobileDisplayMode = useSelector(App.selectors.isMobileDisplayMode);
    const isInProgress = useSelector(selectors.isDeleteAccountInProgress);
    const deleteAccount = useAction(actions.deleteAccount);
    const clearForm = useAction(App.actions.clearForm, DELETE_ACCOUNT_FORM);
    const onSetFormValue = useAction(App.actions.setFormValue, DELETE_ACCOUNT_FORM);
    useEffect(()=>()=>{
            clearForm();
        }, []);
    const submitForm = ({ password })=>{
        deleteAccount(password);
    };
    const processForm = App.hooks.useFormProcessing(DELETE_ACCOUNT_FORM, submitForm);
    const onSubmit = ()=>{
        processForm(formValues, validatorRules);
    };
    const onCancel = ()=>{
        history.push(backUrl);
    };
    return /*#__PURE__*/ _jsxs(Form, {
        onSubmit: onSubmit,
        children: [
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx(FormGroup, {
                    id: "password",
                    labelMessage: messages.labels.password,
                    formValues: formValues,
                    isOneLiner: !isMobileDisplayMode,
                    children: /*#__PURE__*/ _jsx(Input, {
                        type: "password",
                        placeholder: messages.placeholders.yourPassword,
                        onChange: onSetFormValue
                    })
                })
            }),
            /*#__PURE__*/ _jsx(ButtonsContainer, {
                children: /*#__PURE__*/ _jsxs("div", {
                    className: cn('row', {
                        'flex-column-reverse': isMobileDisplayMode
                    }),
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: isMobileDisplayMode ? 'col-12' : 'col-6',
                            children: /*#__PURE__*/ _jsx(Button, {
                                styleModifier: isMobileDisplayMode ? 'secondary' : 'primary',
                                labelMessage: App.messages.buttons.cancel,
                                className: cn('btn--block', {
                                    'mt-5': isMobileDisplayMode
                                }),
                                onClick: onCancel
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: isMobileDisplayMode ? 'col-12' : 'col-6',
                            children: /*#__PURE__*/ _jsx(Button, {
                                type: "submit",
                                styleModifier: "danger",
                                labelMessage: messages.buttons.deleteAccount,
                                className: "btn--block btn--filled",
                                isDisabled: isClean,
                                isInProgress: isInProgress
                            })
                        })
                    ]
                })
            })
        ]
    });
};
export default DeleteAccountForm;
